module.exports = __webpack_public_path__ + "static/media/registry_publish_champagne.ad4b8808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/registry_publish_champagne.svg
// module id = 2447
// module chunks = 51